import tree from '@/components/tree.vue'
import { zzsh } from '@/axios'
import Page from '@/components/page.vue'
import DelData from '@/components/delToast.vue'
import myTables from '@/components/tables/tables.vue'
import { Message } from 'element-ui'
import {bsid} from '@/common/common.js'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				year: "",
				month: "",
				name2: "",
				page: 1,
			},
			delList:[],
			files:[],
			// 党委上传文件列表
			dwFlies:{
				dwid:this.$store.state.user.userinfo.dwid,
				files:[]
			},
			tableData:[],
			// 活动类型列表
			totalPage:0,
			tableHeader: [     // 表头
				{prop: 'title', label: '活动主题'},
				{prop: 'uid1', label: '谈话人',width:"110"},
				{prop: 'name2', label: '谈话对象',width:"160"},
				{prop: 'gu_name', label: '党组织',width:"160"},
				{prop: 'day', label: '时间',},
				// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '120',
					oper: [
						{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
						{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
						{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
		}
	},
	components:{tree,Page,DelData,myTables},
	methods:{
		// 数据
		dataList(){
			that.tableData = [];
			zzsh.organTalkList(that.getdata).then(res => {
				if(res.data.pagedata.length > 0){
					that.tableData = res.data.pagedata;
				}
				that.totalPage = res.data.count;
			})
		},
		// 详情
		showDetail(data){
			that.$router.push({
				path:"/txth_detail",
				query:{
					id:data.id,
				}
			})
		},
		// 编辑
		edit(data){
			that.$router.push({
				path:"/txth_add",
				query:{
					type:'edit',
					id:data.id
				}
			})
		},
		// 新增活动
		goAdd(){
			that.$router.push({
				path:'/txth_add',
				query:{
					type:'add'
				},
			})
		},
		// 部分禁用删除
		selectEnable(row, rowIndex) {
			if (row.uid == that.$store.state.user.userinfo.id) {
			  return true
			}
		 },
		// 一键删除
		selectList(value){
			that.delList =value;
		},
		delAll(){
			if(that.delList.length == 0){
				Message.warning('请先选择要删除得数据')
			}else{
				that.delData();
			}
		},
		//	删除操作
		delData(){
			that.$refs.delDatas.showToast(res => {
				if(res){
					zzsh.delOrganTalk({
						id:that.delList,
					}).then(res => {
						if(res.code == 200){
							Message({
								type: 'success',
								message: '删除成功!'
							})
						}else{
							Message({
								type: 'error',
								message: res.msg
							})
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}
			})
		},
		// 删除
		del(data){
			that.delList = [];
			that.delList = [data.id];
			that.delData();
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.dw = data.dw;
			that.getdata.page = 1;
			that.dataList();
		},
		// 分页筛选
		changedata(curret){
			var that = this;
			that.getdata.page = curret;
			that.dataList();
		},
		// 上传进度
		uploadProcess(event, file, fileList) {
			const loading = this.$loading({
				lock: true,
				text: '上传中请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			});
			if(Math.floor(event.percent) == 100){
				loading.close();
			}
		},
		// 提交党委文件
		subDwFiles(){
			zzsh.addTalkFiles(that.dwFlies).then(res => {
				if(res.code == 200){
					that.dwFiles();
					that.dwFlies.files = [];
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 党委上传文件列表
		dwFiles(){
			that.dwFlies.files = [];
			zzsh.talkFilesList({
				dwid:this.$store.state.user.userinfo.dwid
			}).then(res => {
				if(res.code == 200){
					that.dwFlies.files = res.data;
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 删除党委上传文件
		delDwFiles(id){
			zzsh.delTalkFiles({
				dwid:this.$store.state.user.userinfo.dwid,
				id:id
			}).then(res => {
				if(res.code == 200){
					that.dwFiles();
				}else{
					Message({
						type:"error",
						message:res.msg
					})
				}
			})
		},
		// 支部下载党委上传的文件
		zbDownloadFile(url){
			if(url){
				location.href = url;
			}else{
				Message({
					type:"error",
					message:"下载失败"
				})
			}
		},
		// 文件上传限制
		limitFiles(file){
			var isJPG = file.type === 'application/pdf' 
				|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
				|| file.type === 'application/msword';
			var isLt2M = file.size / 1024 / 1024 < 20;
			if (!isJPG) {
				Message.error('仅支持pdf、doc、docx文件');
				return false;
			}
			if (!isLt2M) {
				Message.error('上传文件大小不能超过 20MB!');
				return false;
			}
			if(that.dwFlies.files.length>=4){
				Message.error("最多可传4个文件")
				return false;
			}
		},
		// 上传文件成功
		success1(res, file) {
			if(res.code == 200){
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					url:res.data.src
				}
				that.dwFlies.files = [];
				that.dwFlies.files.push(data);
				that.subDwFiles();
			}else{
				Message.error('上传失败');
			}
		},
	},
	mounted() {
		that.dataList();
		that.dwFiles();
	},
	created() {
		that = this;
	}
}